import { Injectable } from '@angular/core'
import { BehaviorSubject, Subject, Observable } from 'rxjs';

export class SideBarFeature {
    icon:string;
    title:string;
    data:any;
    mapEnabled:boolean;
}

@Injectable({
    providedIn: 'root'
})
export class SideBarService {
    private features$:BehaviorSubject<SideBarFeature[]>;
    private featureSelected$:Subject<any>;
    private featureSelectedEcql$: Subject<any>;


    constructor() {
        this.features$ = new BehaviorSubject<SideBarFeature[]>([]);
        this.featureSelected$ = new Subject<any>();
        this.featureSelectedEcql$ = new Subject<boolean>();
    }

    public configurationChanges():Observable<SideBarFeature[]> {
        return this.features$.asObservable();
    }

    public configure(features:SideBarFeature[]) {
        this.features$.next(features);
    }

    public selectFeature(feature: SideBarFeature, options: any) {
        this.featureSelected$.next({feature: feature, opt: options});
    }

    public featureSelected():Observable<any> {
        return this.featureSelected$.asObservable();
    }

    public featureSelectedEcql():Observable<boolean> {
        return this.featureSelectedEcql$.asObservable();
        } 

    public setEcql(){
        this.featureSelectedEcql$.next(true);
        } 
}